import "./styles.css";
import { EditOutlined, UserOutlined } from "@ant-design/icons";

const Avatar = ({ image, onClick }) => {
  return (
    <div className="avatar">
      <div className="avatar-content">
        {image ? (
          <img alt="avatar" width={"100%"} height={"100%"} className="resize-cover" src={image} />
        ) : (
          <UserOutlined style={{ fontSize: 60, color: "#fff" }} />
        )}
        <div className="edit-avatar" onClick={onClick}>
          <EditOutlined style={{ fontSize: 60, color: "#fff" }} />
        </div>
      </div>
    </div>
  );
};

export { Avatar };
